import { render, staticRenderFns } from "./ItemDetailMisc.vue?vue&type=template&id=44841536&scoped=true"
import script from "./ItemDetailMisc.vue?vue&type=script&lang=js"
export * from "./ItemDetailMisc.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailMisc.vue?vue&type=style&index=0&id=44841536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44841536",
  null
  
)

export default component.exports